import * as React from 'react';
import { Button, Modal, ModalHeader, ModalBody, CardLink } from 'reactstrap';
import Icon from "components/Varios/Icons.js";

const style = {
    height: 'auto',
    padding: '0px',
};

export default class FileDownload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle = (e) => {
        e.preventDefault();
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    handleClick = (e) => {
        e.preventDefault();
        let name = e.target.dataset.name;
        let url = e.target.dataset.url;
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                });
            });
    }

    renderButton() {
        return (
            <>
                {this.props.card ?
                    <CardLink onClick={this.props.eventEdit} 
                        //onClick={this.handleToggle}
                         href="#">
                        <i className="fas fa-download" aria-hidden="true"></i>
                    </CardLink>
                :
                <Button style={{ backgroundColor: "#517ED3" }} className="m-0 p-1" onClick={this.handleToggle}>
                    {/*<i className="fas fa-download" aria-hidden="true"></i>*/}
                    {this.props.icon.startsWith("fa-") ? (<i className={"fas " + this.props.icon} aria-hidden="true"></i>) : (<Icon kind={this.props.icon} fill='#FFFFFF' width={19} height={19} />)}
                    </Button>
                }
            <Modal size="md" isOpen={this.state.isOpen} toggle={this.toggle} >
                <ModalHeader toggle={this.handleToggle}>DESCARGAR EVIDENCIA</ModalHeader>
                <ModalBody style={style}>
                    <div>
                        <ul>
                            {this.props.files.map(file => {
                                return (
                                    <li key={file.name}>
                                        <label onClick={this.handleClick} data-name={file.name} data-url={file.url}>{file.name}</label>
                                        {/*<i className="fas fa-file" aria-hidden="true"></i>*/}
                                        {this.props.icon.startsWith("fa-") ? (<i className={"fas " + this.props.icon} aria-hidden="true"></i>) : (<Icon kind={this.props.icon} fill='#FFFFFF' width={27} height={27} />)}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </ModalBody>
            </Modal>
            </>
        );
    }

    render() {
        let contents = this.props.files.length > 0

            ? this.renderButton()

            : "";

        return this.props.card ?
            < >{contents}</>
                :
                <div className="col-md-3 col-xs-3" style={{ float: "right" }}>{contents}</div>;
        
    }

}
